import { ThemeProvider } from "@emotion/react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { createTheme, styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import NormalButton from "components/atoms/Button/NormalButton";
import PriceStr from 'components/atoms/String/PriceStr';
import React from 'react';



const colortheme = createTheme({
    palette: {
        primary: {
            main: "#292739",
        },
    },
    typography: {
        fontFamily: ["lato"].join(","),
    },
});

const ParaText = styled(Typography)(({ theme }) => ({
    fontSize: "1rem",
    color: "#ffffff",
}));

const SmallText = styled(Typography)(({ theme }) => ({
    fontSize: ".8rem",
    color: "#ffffff",
}));

const TitleText = styled(Typography)(({ theme }) => ({
    fontSize: "2.4rem",
    fontWeight: "bold",
    color: "#ffffff",
}));

const RewardsSidebar = () => {

    return (
        <React.Fragment>
            <ThemeProvider theme={colortheme}>
                <Box>
                    <TitleText style={{ margin: "1rem 0", fontSize: "1.6rem" }}>
                        How the jackpot works
                    </TitleText>
                    <ParaText style={{ color: "#c1c1c1" }}>
                        The jackpot is the sum of all the tickets submitted by the participants. To participate, submit 10 tickets. When the next session arrives, you might win it all!
                    </ParaText>

                    <Grid container style={{ justifyContent: "space-between", margin: "1.8rem 0px", gap: "1rem", }}>
                        <Grid item xs={12}>
                            <NormalButton style={{ width: "100%" }}>
                                <ParaText>
                                    <PriceStr />
                                    <br />
                                    <SmallText>
                                        $8,123
                                    </SmallText>
                                </ParaText>
                            </NormalButton>
                        </Grid>
                    </Grid>

                    <Grid container style={{ justifyContent: "space-between", margin: "1.8rem 0px", gap: "1rem", }}>
                        <Grid item xs={12}>
                            <NormalButton text={"submit 1 ticket"} color={"yellow"} style={{ width: "100%" }} />
                        </Grid>
                    </Grid>
                </Box>
            </ThemeProvider>
        </React.Fragment>
    );
};

export default RewardsSidebar;
